//graphql/estimationDetails.gql
import { gql } from '@apollo/client';

// Query for fetching estimation details
export const ESTIMATION_DETAILS = gql`
  query EstimationDetails($month_year: String!, $region: String!, $energy_type: String!) {
    estimationDetails(month_year: $month_year, region: $region, energy_type: $energy_type) {
      used {
        meterId
        meterNumber
        name
        lastMonth
        thisMonth
        percentChange
        include
        readType
        priorMonthReadType
        approvalStatus
      }
      excluded {
        meterId
        meterNumber
        name
        lastMonth
        thisMonth
        percentChange
        include
        readType
        priorMonthReadType
        approvalStatus
      }
      estimationFactor
      formula
      isAnyMeterApprovedForMonth
    }
  }
`;

// Mutation for updating exclusions & recalculating
export const UPDATE_EXCLUSION_RECALCULATE = gql`
  mutation UpdateExclusionAndRecalculate(
    $month_year: String!
    $region: String!
    $energy_type: String!
    $exclusions: [ExclusionInput!]!
  ) {
    updateExclusionAndRecalculate(
      month_year: $month_year
      region: $region
      energy_type: $energy_type
      exclusions: $exclusions
    ) {
      used {
        meterId
        meterNumber
        name
        lastMonth
        thisMonth
        percentChange
        include
        readType
        priorMonthReadType
        approvalStatus
      }
      excluded {
        meterId
        meterNumber
        name
        lastMonth
        thisMonth
        percentChange
        include
        readType
        priorMonthReadType
        approvalStatus
      }
      estimationFactor
      formula
      isAnyMeterApprovedForMonth
    }
  }
`;
